import { popupWindow } from '@affine/core/utils';

import { getUrlLogin } from '../api';

export const signin = () => popupWindow(getUrlLogin());
